export default __webpack_public_path__ + "combine-accounts.7337efc0.svg";